module.exports = __webpack_public_path__ + "img/8_ava.f29c9782.jpg";